import { useEffect } from "react";

/**
 * Prevents pinch-to-zoom on mobile devices by updating the viewport meta tag.
 * Restores the original viewport on unmount.
 */
export function usePreventMobileZoom() {
  useEffect(() => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (!isMobile) return;

    const meta = document.querySelector('meta[name="viewport"]');
    if (!meta) return;

    const original = meta.getAttribute("content") || "";
    meta.setAttribute(
      "content",
      "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    );

    return () => {
      meta.setAttribute("content", original);
    };
  }, []);
}
